export default __webpack_public_path__ + "static/media/Dhyan-Mantra.ae944c10.ogg";